module.exports = __webpack_public_path__ + "img/headshot-kati-pylkkanen@2x.f5ea6574.png";